__turbopack_context__.v({
  "root": "styles-module-scss-module___3Og_W__root",
});
